import React, { useState } from 'react';
import { 
  Grid, 
  Box, 
  Typography, 
  TextField,
  Button,
  Alert,
  Divider,
  CircularProgress,
  Select,
  MenuItem,
} from '@mui/material';
import { fazerSolicitacaoPost } from '../service/http';

export default function Form() {

  const [state, setState] = useState({
    id: 1,
    age: 0,
    sex: true,
    admissionCondition: false,
    healthSystemPayer: false,
    valveReplacement: false,
    chronicKidneyDisease: false,
    acuteRenalFailure: false,
    heartFailure: false,
    steAcs: false,
    nonSteAcs: false,
  });

  const [btn, setBtn] = useState(true);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  const [permanencia, setPermanencia] = useState('');

  const handleAge = (event) => {
    if (event.target.name === 'age') {
      if (event.target.value < 18 || event.target.value > 130) {
        setBtn(true);
      }
      else {
        setBtn(false);
      }
    }
    setState({
      ...state,
      [event.target.name]: event.target.value
    })
  }

  const handleValue = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.value
    })
  }

  const handleExecute = async () => {
    try {
      setError(false);
      setPermanencia('');
      setLoading(true);

      const data = { 
        "id_observacao": 1,
        "Age": state.age,
        "sex": state.sex ? "1" : "0",
        "Admission Condition": state.admissionCondition ? "1" : "0",
        "Health System Payer": state.healthSystemPayer ? "1" : "0",
        "Valve Replacement": state.valveReplacement ? "1" : "0",
        "Chronic Kidney Disease": state.chronicKidneyDisease ? "1" : "0",
        "Acute Renal Failure": state.acuteRenalFailure ? "1" : "0",
        "Heart Failure": state.heartFailure ? "1" : "0",
        "STE ACS": state.steAcs ? "1" : "0",
        "Non STE ACS": state.nonSteAcs ? "1" : "0",
      };
      
      const response = await fazerSolicitacaoPost(data);
      
      setPermanencia(response[0].permanencia_prevista);
    } catch (error) {
      console.error('Erro na solicitação POST:', error);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      <div className="box-container">
        <Typography variant="h6" className="box-container" gutterBottom>
          Form Diagnose
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <TextField
              required
              type="number"
              name="age"
              variant="standard"
              label="Patient Age (18 - 130)"
              onChange={handleAge}
            />
          </Grid>
          <Grid 
            item 
            xs={12} 
            sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} 
          >
            <span>Sex</span>
            <Select
              labelId="sex-label"
              id="sex"
              name="sex"
              defaultValue={true}
              onChange={handleValue}
            >
              <MenuItem value={true}>Female</MenuItem>
              <MenuItem value={false}>Male</MenuItem>
            </Select>
          </Grid>
          <Grid 
            item 
            xs={12} 
            sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} 
          >
            <span>Non-Elective Surgery</span>
            <Select
              labelId="admissionCondition-label"
              id="admissionCondition"
              name="admissionCondition"
              defaultValue={false}
              onChange={handleValue}
            >
              <MenuItem value={true}>Yes</MenuItem>
              <MenuItem value={false}>No</MenuItem>
            </Select>
          </Grid>
          <Grid 
            item 
            xs={12} 
            sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} 
          >
            <span>Public Health System</span>
            <Select
              labelId="healthSystemPayer-label"
              id="healthSystemPayer"
              name="healthSystemPayer"
              defaultValue={false}
              onChange={handleValue}
            >
              <MenuItem value={true}>Yes</MenuItem>
              <MenuItem value={false}>No</MenuItem>
            </Select>
          </Grid>
          <Grid 
            item 
            xs={12} 
            sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} 
          >
            <span>Valve Replacement</span>
            <Select
              labelId="valveReplacement-label"
              id="valveReplacement"
              name="valveReplacement"
              defaultValue={false}
              onChange={handleValue}
            >
              <MenuItem value={true}>Yes</MenuItem>
              <MenuItem value={false}>No</MenuItem>
            </Select>
          </Grid>
          <Grid 
            item 
            xs={12} 
            sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} 
          >
            <span>Chronic Kidney Disease</span>
            <Select
              labelId="chronicKidneyDisease-label"
              id="chronicKidneyDisease"
              name="chronicKidneyDisease"
              defaultValue={false}
              onChange={handleValue}
            >
              <MenuItem value={true}>Yes</MenuItem>
              <MenuItem value={false}>No</MenuItem>
            </Select>
          </Grid>
          <Grid 
            item 
            xs={12} 
            sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} 
          >
            <span>Acute Renal Failure</span>
            <Select
              labelId="acuteRenalFailure-label"
              id="acuteRenalFailure"
              name="acuteRenalFailure"
              defaultValue={false}
              onChange={handleValue}
            >
              <MenuItem value={true}>Yes</MenuItem>
              <MenuItem value={false}>No</MenuItem>
            </Select>
          </Grid>
          <Grid 
            item 
            xs={12} 
            sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} 
          >
            <span>Heart Failure</span>
            <Select
              labelId="heartFailure-label"
              id="heartFailure"
              name="heartFailure"
              defaultValue={false}
              onChange={handleValue}
            >
              <MenuItem value={true}>Yes</MenuItem>
              <MenuItem value={false}>No</MenuItem>
            </Select>
          </Grid>
          <Grid 
            item 
            xs={12} 
            sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} 
          >
            <span>STE ACS</span>
            <Select
              labelId="steAcs-label"
              id="steAcs"
              name="steAcs"
              defaultValue={false}
              onChange={handleValue}
            >
              <MenuItem value={true}>Yes</MenuItem>
              <MenuItem value={false}>No</MenuItem>
            </Select>
          </Grid>
          <Grid 
            item 
            xs={12} 
            sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} 
          >
            <span>Non STE ACS</span>
            <Select
              labelId="nonSteAcs-label"
              id="nonSteAcs"
              name="nonSteAcs"
              defaultValue={false}
              onChange={handleValue}
            >
              <MenuItem value={true}>Yes</MenuItem>
              <MenuItem value={false}>No</MenuItem>
            </Select>
          </Grid>
        </Grid>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            variant="contained"
            sx={{ mt: 3, ml: 1 }}
            className="button-action"
            onClick={handleExecute}
            disabled={btn}
          >
            { !loading ? 'Execute Prediction' : <CircularProgress className="progression" /> }
          </Button>
        </Box>
        {
          error ? 
            <Box className="box-reponse">
              <Divider variant="middle" />
              <br/>
              <Alert severity="error">Error during your request, please wait to try again.</Alert>
            </Box>
            : ''
        }
        {
          permanencia ? 
            <Box className="box-response">
              <br/>
              <Divider variant="middle" />
              <br/>
              <Typography gutterBottom>
                <b>Length of stay (days): </b> {permanencia}
              </Typography>
            </Box>
            : ''
        }
        
      </div>
    </React.Fragment>
  );
}